import cx from 'classnames'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import InfoLine from '../../../OrderSummary/components/InfoLine/InfoLine'

import './SubMovieImg.scss'

const SubMovieImg = ({ cinemaType, imgUrl, imgAlt }) => {
    const intl = useIntl()

    return (
        <Container fluid className="sub-movie-img d-flex flex-column">
            <InfoLine text={intl.formatMessage({ id: 'yourOrder.nextFilm' })} />
            <div className={cx(`sub-movie-img--poster ${cinemaType} ${!imgUrl && 'd-none'}`)}>
                <img src={imgUrl} alt={imgAlt} className={'h-auto'} loading={'lazy'} />
            </div>
        </Container>
    )
}

export default SubMovieImg
